import axios from "axios";

const url = process.env.REACT_APP_BACKEND_URL;

export const CheckForgotToken = async (query) => {
  return await axios.post(url + "validateForgotPassword", query);
};
